module.exports = __webpack_public_path__ + "images/80747f1b0ef3870c4fded45da49c5b92.jpg";